/**
 * Edge-pan setting — whether moving the cursor to a screen edge pans the camera.
 *
 * Was disabled by default (2026-06-27, playtest): edge-pan fought with HUD
 * buttons sitting near the viewport edges (a click near an edge started a
 * pan). Re-enabled by DEFAULT (2026-07-02) now that main.ts's panCamera()
 * gates every edge-pan on a HUD-guard (`isPointerOverCanvas` — a live
 * elementFromPoint hit-test, only pans when the cursor is over the game
 * canvas itself) AND `isAnyModalOpen()` (no pan while a menu/modal owns
 * input), so a click on a HUD element near an edge can no longer trigger an
 * inadvertent pan. Players can still turn it off from the settings panel;
 * the choice persists to localStorage and takes precedence over this default
 * (see load() below).
 *
 * The edge-pan block in main.ts is gated on getEdgePanEnabled().
 */
const STORAGE_KEY = "tribez.edgePan";

export const EDGE_PAN_DEFAULT = true;

let enabled = load();

function load(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return EDGE_PAN_DEFAULT;
    return raw === "1";
  } catch {
    return EDGE_PAN_DEFAULT;
  }
}

export function getEdgePanEnabled(): boolean {
  return enabled;
}

export function setEdgePanEnabled(on: boolean): void {
  enabled = on;
  try {
    localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
  } catch {
    /* private-mode / quota — keep the in-memory value, just don't persist. */
  }
}
